module.exports = __webpack_public_path__ + "img/djezzy_logo.171dd388.png";